<template>
    <div>
        <img :src="'/media/header/series.jpg'" alt="Series" class="img-fluid mb-4 rounded">
<!--        <page-header :title="$t('pages.series.index.title')" icon-class="mdi mdi-television"/>-->

        <static-loading-indicator-icon/>
        <div v-if="!$store.getters.shouldLoadLocal">

            <div class="row">
                <div class="col-xl-6 mb-4" v-for="series in seriesList">
                    <series-card :series="series"></series-card>
                </div>
            </div>

            <div class="mt-3">
                <pagination :data="paginationData" @pagination-change-page="getSeries"></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../Includes/PageHeader";
import VideoSeriesRepository from "../../repositories/Gym/VideoSeriesRepository";
import StaticLoadingIndicatorIcon from "../Includes/StaticLoadingIndicatorIcon";
import SeriesCard from "./Includes/SeriesCard";
export default {
    name: "SeriesList",
    components: {SeriesCard, StaticLoadingIndicatorIcon, PageHeader},
    data: () => ({
       seriesList: [],
       paginationData: {}
    }),
    mounted() {
        this.getSeries(1);
    },
    methods: {
        getSeries(page = 1) {
            VideoSeriesRepository
                .getPaginated(page)
                .then((res) => {
                    this.seriesList = res.data.data;
                    this.paginationData = res.data.meta;
                })
        }
    }
}
</script>

<style scoped>

</style>
